import React from "react";
import { cn } from "../../utils/classNames";

interface LoadingStateProps {
  /** Completes the sentence "Loading …" — e.g. "products", "meal subscriptions". */
  label?: string;
  /** Spinner size. `sm` suits inline areas, `md` full panels. */
  size?: "sm" | "md";
  className?: string;
}

/**
 * Shared "still fetching" panel.
 *
 * Screens without one render their empty state while a request is in flight,
 * which tells the user they have no data when the answer isn't known yet.
 * Reach for this whenever a list or form is waiting on a first load.
 */
export default function LoadingState({ label, size = "md", className }: LoadingStateProps) {
  return (
    <div
      className={cn("py-8 text-center sm:py-12", className)}
      role="status"
      aria-live="polite"
    >
      <div
        className={cn(
          "mx-auto mb-3 animate-spin rounded-full border-b-2 border-indigo-600",
          size === "sm" ? "h-5 w-5" : "h-8 w-8"
        )}
      />
      <span className="text-sm text-gray-500 sm:text-base">
        {label ? `Loading ${label}…` : "Loading…"}
      </span>
    </div>
  );
}
